import { IoMdCheckmark } from 'react-icons/io';
import { LuMinus } from 'react-icons/lu';

import ActionsButton from 'components/tables/AGGrid/ActionsButton';

const booleanCellRenderer = (params) =>
    params.value ? (
        <IoMdCheckmark fontSize="large" />
    ) : (
        <LuMinus fontSize="large" />
    );

/**
 * Builds the AG Grid column definitions for the Special Numbers table.
 *
 * @param {object}   params
 * @param {function} params.onEditSpecialNumber Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getSpecialNumbersTableColumns = ({ onEditSpecialNumber }) => [
    {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 150,
        sort: 'asc',
    },
    {
        headerName: 'Pattern',
        field: 'pattern',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Active',
        field: 'isActive',
        width: 120,
        filter: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        cellRenderer: booleanCellRenderer,
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsButton
                actions={[
                    {
                        label: 'Edit Special Number',
                        onClick: () => onEditSpecialNumber(params.data),
                    },
                ]}
            />
        ),
    },
];
